import { createContext, useContext, useState } from "react";
import { UseGetCurrentUser } from "hooks/use-get-current-user";

interface UserContextType {
  user: any;
  saveUserData: (data: any) => void; // Define the function type as needed
  refreshCurrentUser: () => Promise<void>; // Define the function type as needed
}
const CurrentUserContext = createContext<UserContextType | null>(null);

function useCurrentUserContext() {
  const context = useContext(CurrentUserContext);

  if (!context) {
    throw new Error(
      `useGetUserContext must be used within CurrentUserProvider`
    );
  }

  return context;
}

function useIsUserLogin() {
  const context = useContext(CurrentUserContext);

  if (!context) {
    throw new Error(`useIsUserLogin must be used within CurrentUserProvider`);
  }

  return !!context.user?.firstName;
}

function CurrentUserProvider({ ...props }) {
  const [user, setUser] = useState<any>(null);
  const userHook = UseGetCurrentUser();

  async function getUserData() {
    const data = await userHook.refetch();
    if (data) {
      setUser(data);
    }
  }

  return (
    <CurrentUserContext.Provider
      value={{
        user,
        saveUserData: setUser,
        ...userHook,
        refreshCurrentUser: getUserData,
      }}
      {...props}
    />
  );
}

export { useCurrentUserContext, CurrentUserProvider, useIsUserLogin };
